// extracted by mini-css-extract-plugin
export default {"label":"Label-module__label___g5lHA","icon":"Label-module__icon___tLfEF"};